import { request } from "./authApi";

// Admin only (Section C). Used by RichTextEditor.js to embed images
// inside rich text content — distinct from issue cover uploads
// (issuesApi.js), which carry their file under a different field name
// as part of the issue's own create form.
export function uploadContentImage(token, file) {
  const formData = new FormData();
  formData.append("image", file);
  return request("/uploads/images", { method: "POST", body: formData, token });
}
